export const wittyLinkReference = 'XVL122C / XVL122S'
export const wittyFlexReference = 'XDV111E'
export const cintechReference = 'XEV1K07T2S / XEV1K22T2S'
export const eebusReference = 'XEV1S22T2TF'

const wbTypeToModbusReference: Record<string, ModbusDeviceReference> = {
  '6': cintechReference,
  '8': wittyLinkReference,
  '11': wittyFlexReference,
}

const modbusReferenceToWbType: Record<ModbusDeviceReference, WbType> = {
  [cintechReference]: '6',
  [wittyLinkReference]: '8',
  [wittyFlexReference]: '11',
}

type WbType = '6' | '7' | '8' | '11'

export const ModbusReferences = [cintechReference, wittyLinkReference, wittyFlexReference] as const
export const DeviceReferences = [...ModbusReferences, eebusReference] as const

export type ModbusDeviceReference = (typeof ModbusReferences)[number]
export type DeviceReference = (typeof DeviceReferences)[number]

export function mapWbTypeToModbusReference(wbType: string | undefined | null): ModbusDeviceReference {
  if (!wbType) return cintechReference
  return wbTypeToModbusReference[wbType] ?? cintechReference
}

export function mapModbusReferenceToWbType(reference: ModbusDeviceReference): WbType {
  return modbusReferenceToWbType[reference] ?? '6'
}
